import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetFirstPasswordMutationVariables = Types.Exact<{
  data: Types.SetNewPasswordInput;
}>;


export type SetFirstPasswordMutation = { __typename?: 'Mutation', setFirstPassword: boolean };


export const SetFirstPasswordDocument = gql`
    mutation SetFirstPassword($data: SetNewPasswordInput!) {
  setFirstPassword(data: $data)
}
    `;
export type SetFirstPasswordMutationFn = Apollo.MutationFunction<SetFirstPasswordMutation, SetFirstPasswordMutationVariables>;

/**
 * __useSetFirstPasswordMutation__
 *
 * To run a mutation, you first call `useSetFirstPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFirstPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFirstPasswordMutation, { data, loading, error }] = useSetFirstPasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetFirstPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetFirstPasswordMutation, SetFirstPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFirstPasswordMutation, SetFirstPasswordMutationVariables>(SetFirstPasswordDocument, options);
      }
export type SetFirstPasswordMutationHookResult = ReturnType<typeof useSetFirstPasswordMutation>;
export type SetFirstPasswordMutationResult = Apollo.MutationResult<SetFirstPasswordMutation>;
export type SetFirstPasswordMutationOptions = Apollo.BaseMutationOptions<SetFirstPasswordMutation, SetFirstPasswordMutationVariables>;